import React from 'react';
import {Redirect, Route, Switch} from "react-router-dom";
import {Error404} from "views/Error/404";
import NotAllowed from "v4/components/ui/NotAllowed/NotAllowed";
import usePolRouter from "v4/features/front/routing/hooks/usePolRouter";

export default function PolRouter({isExternal, isProtected}) {
    const {groupedRoutes, redirectTo} = usePolRouter(isExternal, isProtected);

    if (redirectTo) return <Redirect to={redirectTo}/>

    return (
        <Switch>
            {groupedRoutes.map(route => {
                return (
                    route.subMenu?.length > 0
                        ? (
                            route.subMenu.map(subMenu => {
                                return (
                                    <Route key={subMenu.id}
                                           exact
                                           path={subMenu.path}
                                           component={subMenu.testIsGranted?.() ? subMenu.component : NotAllowed}/>
                                )
                            })
                        )
                        : <Route key={route.groupCode ?? route.id}
                                 exact
                                 path={route.path}
                                 component={route.testIsGranted?.() ? route.component : NotAllowed}/>
                )
            })}
            <Route component={Error404}/>
        </Switch>
    )
}
